<template>
    <div class="container bng-narrow-container bng-withdrawal-codes">
        <div
            v-if="!haveWithdrawalPins"
            class=""
        >{{"components.pages.withdrawal-codes.no codes" | translate}}</div>
        <withdrawal-codes-list />
    </div>
</template>
<script>
import pinService from '../../../../../../_common/services/pin.service';

import WithdrawalCodesList from '../../../common/withdrawal-codes-list/withdrawal-codes-list.vue';

export default {
    name: 'site-pages-layout',
    components: { WithdrawalCodesList },
    data() {
        return {
            haveWithdrawalPins: false
        }
    },
    async created() {
        let pins = await pinService.getNotAppliedWithdrawPins();
        this.haveWithdrawalPins = pins && pins.length;
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/withdrawal-codes/withdrawal-codes.vue